import { Partner } from '@provision/entity-types';
import type { AutoCompleteOption } from 'src/components/Forms/types';

export enum CompanyInfoField {
  Address = 'address',
  City = 'city',
  State = 'state',
  Zip = 'zip',
  OfficePhone = 'mainOfficePhone',
  TimeZone = 'timeZone',
  BillingEmail = 'billingEmail',
  WebsiteUrl = 'websiteUrl',
}

export interface CompanyInfoFormValues {
  [CompanyInfoField.Address]: string;
  [CompanyInfoField.City]: string;
  // `FormAutocomplete` writes the whole selected option back into the field, while
  // `getFormValuesFromPartner` seeds it with the bare code from the partner record.
  [CompanyInfoField.State]: string | AutoCompleteOption;
  [CompanyInfoField.Zip]: string;
  [CompanyInfoField.OfficePhone]: string;
  [CompanyInfoField.TimeZone]: string;
  [CompanyInfoField.BillingEmail]: string;
  [CompanyInfoField.WebsiteUrl]: string;
}

export type CompanyInfoPartner = Pick<
  Partner,
  | 'partnerId'
  | 'businessName'
  | 'zendeskDomain'
  | 'supportEmail'
  | 'supportPhone'
  | 'membershipEmail'
  | 'membershipSalesCalendlyLink'
  | 'address'
  | 'city'
  | 'state'
  | 'zip'
  | 'timeZone'
  | 'billingEmail'
  | 'websiteUrl'
> & {
  mainOfficePhone: string | null;
};

export const DEFAULT_FORM_VALUES: CompanyInfoFormValues = {
  [CompanyInfoField.Address]: '',
  [CompanyInfoField.City]: '',
  [CompanyInfoField.State]: '',
  [CompanyInfoField.Zip]: '',
  [CompanyInfoField.OfficePhone]: '',
  [CompanyInfoField.TimeZone]: '',
  [CompanyInfoField.BillingEmail]: '',
  [CompanyInfoField.WebsiteUrl]: '',
};

export const getStateCode = (state: CompanyInfoFormValues['state']): string =>
  typeof state === 'string' ? state : String(state?.value ?? state?.id ?? '');

export const getFormValuesFromPartner = (
  partner: CompanyInfoPartner | null,
): CompanyInfoFormValues => ({
  [CompanyInfoField.Address]: partner?.address || '',
  [CompanyInfoField.City]: partner?.city || '',
  [CompanyInfoField.State]: partner?.state || '',
  [CompanyInfoField.Zip]: partner?.zip || '',
  [CompanyInfoField.OfficePhone]: partner?.mainOfficePhone || '',
  [CompanyInfoField.TimeZone]: partner?.timeZone || '',
  [CompanyInfoField.BillingEmail]: partner?.billingEmail || '',
  [CompanyInfoField.WebsiteUrl]: partner?.websiteUrl || '',
});
